// import React from "react";
// import { Backdrop, CircularProgress } from "@mui/material";

// const GlobalLoader = ({ open = false }) => {
//   return (
//     <Backdrop
//       open={open}
//       sx={{
//         color: "#fff",
//         zIndex: (theme) => theme.zIndex.modal + 1,
//       }}
//     >
//       <CircularProgress color="inherit" />
//     </Backdrop>
//   );
// };

// export default GlobalLoader;
import React, { createContext, useContext, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const showLoader = () => setLoading(true);
  const hideLoader = () => setLoading(false);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}

      {/* Global Backdrop Loader */}
      <Backdrop
        open={loading}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.modal + 1,
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
